"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisEventHandlerManagerImpl = void 0;
class IrisEventHandlerManagerImpl {
    constructor() {
        this.eventHandlersMap = new Map();
    }
    notifyEvent(key, param) {
        let eventHandlers = this.eventHandlersMap.get(key);
        if (!eventHandlers) {
            return;
        }
        eventHandlers.forEach((eventHandler) => {
            eventHandler.onEvent(param);
        });
    }
    addEventHandler(key, eventHandler) {
        let eventHandlers = this.eventHandlersMap.get(key);
        if (!eventHandlers) {
            eventHandlers = [];
            eventHandlers.push(eventHandler);
            this.eventHandlersMap.set(key, eventHandlers);
            return;
        }
        let item = eventHandlers.find((value) => {
            return value === eventHandler;
        });
        if (!item) {
            eventHandlers.push(eventHandler);
        }
    }
    removeEventHandler(key, eventHandler) {
        let eventHandlers = this.eventHandlersMap.get(key);
        if (!eventHandlers) {
            return;
        }
        eventHandlers.forEach((item, index) => {
            if (item === eventHandler)
                eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.splice(index, 1);
        });
    }
}
exports.IrisEventHandlerManagerImpl = IrisEventHandlerManagerImpl;
